import UploadCategoryImage from "./UploadCategoryImage";

export default UploadCategoryImage;
